import { BankReconciliationWorkspace } from "./BankReconciliationWorkspace";
import { CashAssistantPanel } from "../cashChat/CashAssistantPanel";

export default function BankReconciliationPage() {
  return (
    <div className="flex w-full flex-col gap-4">
      <header>
        <h1 className="text-2xl font-bold text-slate-900">Reconciliation</h1>
        <p className="mt-1 text-sm text-slate-600">
          Match bank and credit card activity to journal entries in your books,
          one account at a time.
        </p>
      </header>

      <BankReconciliationWorkspace />
      <CashAssistantPanel />
    </div>
  );
}
